import { render, staticRenderFns } from "./TextSlice.vue?vue&type=template&id=372b56a8&"
import script from "./TextSlice.vue?vue&type=script&lang=js&"
export * from "./TextSlice.vue?vue&type=script&lang=js&"
import style0 from "./TextSlice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports